import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxPaginationModule } from 'ngx-pagination';
import { ApiService } from 'src/app/services/api.service';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { AppSettings } from './../../services/AppSettings';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { NodataFoundComponent } from '../nodata-found/nodata-found.component';

declare var $: any;

@Component({
  selector: 'app-connections',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InfiniteScrollModule,
    NgxPaginationModule,

    NG_ICON_DIRECTIVES,
    NodataFoundComponent,
  ],
  templateUrl: './connections.component.html',
  styleUrls: ['./connections.component.scss']
})
export class ConnectionsComponent implements OnInit, OnChanges {

  @Input('title') title: any = 'Invite your connections ';
  @Input() inputData: string;
  @Input() suggestion: any;
  headerTitle: any = 'Invite your connections ';
  
  // Two separate lists - one for widget display, one for modal
  userConnecction: Array<any> = []; // For widget display
  modalConnectionList: Array<any> = []; // For modal display
  filteredConnectionList: Array<any> = []; // For filtered results in modal
  
  searchName: any;
  imgUrl: any = AppSettings.photoUrl;
  businessName: any;
  modalRef: BsModalRef;
  commonDatahide: any = {}
  apicalled: boolean = false;
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  admin: Array<any> = [{ src: '1.jpg' }, { src: '2.jpg' }, { src: '3.jpg' }, { src: '4.jpg' }, { src: '5.jpg' },
  { src: '6.jpg' }, { src: '7.jpg' }, { src: '8.jpg' }, { src: '9.jpg' }];
  @Input() maxMin: any = {};
  @Input() page: string;
  viewType: string = "MIN";
  pageName: any = ''
  show: Boolean = true;
  @Input() widgetDesc: string;
  cdr: any;

  // Infinite scroll properties
  isLoading = false;
  /** Business suggestions request in flight (first load / ↻): shows the widget skeleton. */
  loadAPIcall = false;
  stopScroll: boolean = false;
  previousSearchAfterKey: any = null;
  loadedUserIds = new Set(); // Track loaded user IDs to prevent duplicates
  params = {
    limit: 15,
    businessId: null,
    searchAfterKey: null,
    searchContent: null
  };
  items: any[] = [];

  constructor(private auth: ApiService,
    private router: Router,
    private util: UtilService,
    private a_route: ActivatedRoute,
    private _route: ActivatedRoute,
    private modalService: BsModalService, private JobServicecolor: JobService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any
  ) {
    console.log('ConnectionsComponent constructor: widgetData received =', this.widgetData);

    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      if (this.widgetData.inputData) {
        this.inputData = this.widgetData.inputData;
        console.log('ConnectionsComponent constructor: Set inputData =', this.inputData);
      }
      if (this.widgetData.page) {
        this.page = this.widgetData.page;
        console.log('ConnectionsComponent constructor: Set page =', this.page);
      }
      if (this.widgetData.widgetDesc) {
        this.headerTitle = this.widgetData.widgetDesc;
      }
      if (this.widgetData.commonFunction) {
        this.commonFunction = this.widgetData.commonFunction;
        console.log('ConnectionsComponent constructor: commonFunction received');
      }
    } else {
      console.log('ConnectionsComponent constructor: No widgetData received!');
    }
  }

  route(item) {
    // Add a returnUrl parameter to indicate navigation from Connections page
    const queryParams = { ...item, returnUrl: this.router.url };
    this.router.navigate(['personalProfile'], { queryParams });
  }

  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Invite your connections';
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "ConnectionsComponent";
    // Add returnUrl parameter for proper back button handling
    dataPass.returnUrl = this.router.url;
    this.router.navigate(['suggestions'], { queryParams: dataPass });
  }
  // for first and last name
  getInitialName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  // for first and last name
  getColorName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  config = {
    itemsPerPage: 0,
    currentPage: 1,
    totalPages: 0,
  }
  storedPage: any;
  visiblePages: number[] = [];
  totalItems: number = 100;
  /** Business invite suggestions: real `data.total` (null until known) for the
   *  wireframe "+N" bubble after the avatar row. */
  inviteTotal: number | null = null;
  /** Business: false once the suggestion list is empty, so the card hides itself
   *  (like Visitors) — the host's viewadmin() re-shows admin widgets after hide(). */
  showUI = true;

  /** Avatars in the row: 6 on the Business listing page (wider column), 5 elsewhere (Business detail page etc.). */
  get avatarLimit(): number {
    return this.router.url.startsWith('/landingPage/business') ? 6 : 5;
  }

  get inviteMore(): number {
    if (!this.inviteTotal) { return 0; }
    return Math.max(0, this.inviteTotal - Math.min(this.userConnecction.length, this.avatarLimit));
  }
  
  onSearch(event: any) {
  const value = event.target.value || '';
  const searchValue = value.trim();
 
  this.searchName = value;
 
  if (searchValue !== '') {
    this.config.currentPage = 1;
    this.beingTyped = true;
 
    this.filterModalList(value);
  } else if (value.length > 0) {
    // Input contains only spaces
    this.config.currentPage = 1;
    this.beingTyped = true;
 
    this.filterModalList(value);
  } else {
    // Input is completely empty
    this.config.currentPage = this.storedPage;
    this.beingTyped = false;
 
    this.resetFilteredList();
  }
}
 
  
  // Filter the modal list without losing checked status
  filterModalList(searchTerm: string) {
    if (!searchTerm) {
      this.filteredConnectionList = [...this.modalConnectionList];
      return;
    }
    
    const lowerSearchTerm = searchTerm.toLowerCase();
    
    // Create a filtered list but preserve all properties including 'checked'
    this.filteredConnectionList = this.modalConnectionList.filter(user => {
      const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase();
      const title = (user.title || '').toLowerCase();
      
      return fullName.includes(lowerSearchTerm) || title.includes(lowerSearchTerm);
    });
  }
  
  // Reset the filtered list but keep checked status
  resetFilteredList() {
    this.filteredConnectionList = [...this.modalConnectionList];
  }

  pageSize = 15;
  pageNumber = 1;

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    console.log('ConnectionsComponent ngOnInit: inputData =', this.inputData, 'page =', this.page);

    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if (res.master && res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    });

    let a = this._route.pathFromRoot[0]['_routerState']['snapshot'].url;
    let b = a.substr(13, 25);
    if (b == 'communityList') {
      this.pageName = 'COMMUNITY_LIST';
    } else {
      this.pageName = 'BUSINESS_LIST';
    }
    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }

    // Reset scroll state on init
    this.resetScrollState();

    if (this.inputData && this.inputData != null && this.inputData != "") {
      console.log('ConnectionsComponent ngOnInit: Loading data for inputData =', this.inputData);
      if (this.inputData == "BUSINESS") {
        this.show = true;
        this.loadBusinessConnectionData();
      } else if (this.inputData == "COMMUNITY") {
        this.loadCommunityConnectionData();
      } else if (this.inputData == "HOME") {
        this.loadHomeConnectionData();
      }
    } else {
      console.log('ConnectionsComponent ngOnInit: No valid inputData, skipping data load');
    }

    this.config.totalPages = Math.ceil(this.totalItems / this.config.itemsPerPage);
    this.updateVisiblePages();
  }

  // Reset scroll state for new data loading
  resetScrollState() {
    this.items = [];
    this.userConnecction = [];
    this.modalConnectionList = [];
    this.filteredConnectionList = [];
    this.previousSearchAfterKey = null;
    this.stopScroll = false;
    this.isLoading = false;
    this.loadedUserIds.clear(); // Clear the set of loaded user IDs
  }

  loadBusinessConnectionData() {
    console.log('ConnectionsComponent loadBusinessConnectionData: Starting');
    this.util.startLoader();
    this.loadAPIcall = true;

    const businessId = localStorage.getItem('businessId');
    console.log('ConnectionsComponent loadBusinessConnectionData: businessId =', businessId);
    if (!businessId) {
      console.error("ConnectionsComponent loadBusinessConnectionData: No businessId found. Cannot make API request.");
      this.util.stopLoader();
      this.loadAPIcall = false;
      this.showUI = false;
      this.hide(true);
      return;
    }

    const payload = {
      limit: this.pageSize,
      businessId: businessId,
      userId: localStorage.getItem('userId'),
      searchAfterKey: null,
      searchContent: null
    };

    this.auth.create('business/connection/suggestion', payload).subscribe(
      (res) => {
        this.util.stopLoader();
        this.loadAPIcall = false;
        console.log('ConnectionsComponent loadBusinessConnectionData: API Response =', res);

        if (res.status == 404) {
          console.log('ConnectionsComponent loadBusinessConnectionData: 404 response, hiding widget');
          this.showUI = false;
          this.hide(true);
          return;
        }

        if (res && res.code === '00000' && res.data) {
          const { data } = res;

          if (data.connectionInvites && data.connectionInvites.length > 0) {
            console.log('ConnectionsComponent loadBusinessConnectionData: Found', data.connectionInvites.length, 'connections');
            this.showUI = true;
            this.inviteTotal = Number(data.total) || null;
            // Track loaded users to prevent duplicates
            this.userConnecction = [];
            this.modalConnectionList = [];
            this.loadedUserIds.clear();
            
            // Deep clone the data to have separate references for widget and modal
            data.connectionInvites.forEach(user => {
              this.loadedUserIds.add(user.userId);
              this.userConnecction.push({...user});
              
              // Add checked property for modal list
              const modalUser = {...user, checked: false};
              this.modalConnectionList.push(modalUser);
            });
            
            // Initialize filtered list with all connections
            this.filteredConnectionList = [...this.modalConnectionList];
            
            this.items = [...this.userConnecction];
            
            // Extract searchAfterKey from the response
            if (data.searchAfterKey && data.searchAfterKey.length > 0) {
              this.previousSearchAfterKey = data.searchAfterKey;
              this.stopScroll = false;
            } else {
              this.stopScroll = true;
            }
            
            // Update pagination config if needed
            if (data.total) {
              this.config.itemsPerPage = data.total;
              this.totalItems = data.total;
              this.config.totalPages = Math.ceil(this.totalItems / this.pageSize);
              this.updateVisiblePages();
            }
          } else {
            console.log('ConnectionsComponent loadBusinessConnectionData: No connectionInvites in response, hiding widget');
            this.showUI = false;
            this.hide(true);
          }
        } else {
          console.log('ConnectionsComponent loadBusinessConnectionData: Invalid response format, hiding widget');
          this.showUI = false;
          this.hide(true);
        }
      },
      err => {
        console.error('ConnectionsComponent loadBusinessConnectionData: API Error =', err);
        this.util.stopLoader();
        this.loadAPIcall = false;
        this.showUI = false;
        this.hide(true);
      }
    );
  }

  loadCommunityConnectionData() {
    var type = this._route.queryParams['_value'].communityType;
    var isSuperAdmin = this._route.queryParams['_value'].superAdmin;
    var isAdmin = this._route.queryParams['_value'].isAdmin;
    var isJoined = this._route.queryParams['_value'].isJoined;

    if (type == "false" && isSuperAdmin == "true" && isAdmin == "false"
      || type == "false" && isSuperAdmin == "false" && isAdmin == "true"
      || type == "false" && isSuperAdmin == "true" && isAdmin == "true"
      || type == "true" && isSuperAdmin == "true" && isAdmin == "true"
      || type == "true" && isSuperAdmin == "false" && isAdmin == "true"
      || type == "true" && isSuperAdmin == "true" && isAdmin == "false") {
      this.show = true;
    } else if (type == "true" && isJoined == "true") {
      this.show = true;
    } else {
      this.show = false;
    }

    this.util.startLoader();

    this.auth.query("community/connection/suggestion/" + localStorage.getItem('communityId')).subscribe((res) => {
      this.util.stopLoader();
      if (res.status == 404) {
        this.hide(true);
      }
      if (res && res.length != 0 && res != undefined && res != null) {
        if (res['data'] && res['data'] != null && res['data']['connectionInvites'] && res['data']['connectionInvites'] != null && res['data']['connectionInvites'].length != 0) {
          // Separate copies for widget and modal
          this.userConnecction = [...res['data']['connectionInvites']];
          
          // Create modal list with checked property
          this.modalConnectionList = res['data']['connectionInvites'].map(user => ({
            ...user,
            checked: false
          }));
          
          // Initialize filtered list
          this.filteredConnectionList = [...this.modalConnectionList];
          
          // Track loaded user IDs
          this.loadedUserIds.clear();
          this.userConnecction.forEach(user => {
            this.loadedUserIds.add(user.userId);
          });
        } else {
          this.hide(true);
        }
      } else {
        this.hide(true);
      }
    }, err => {
      this.util.stopLoader();
      this.hide(true);
    });
  }

  loadHomeConnectionData() {
    this.util.startLoader();

    this.auth.query("widget/business/connection/suggestion/" + localStorage.getItem('userId')).subscribe((res) => {
      this.util.stopLoader();

      if (res && res.length != 0 && res != undefined && res != null) {
        // Separate copies for widget and modal
        this.userConnecction = [...res];
        
        // Create modal list with checked property
        this.modalConnectionList = res.map(user => ({
          ...user,
          checked: false
        }));
        
        // Initialize filtered list
        this.filteredConnectionList = [...this.modalConnectionList];
        
        // Track loaded user IDs
        this.loadedUserIds.clear();
        this.userConnecction.forEach(user => {
          this.loadedUserIds.add(user.userId);
        });
      } else {
        this.hide(true);
      }
    }, err => {
      this.util.stopLoader();
      this.hide(true);
    });
  }

  // Header refresh icon: reload the list for the current context (same loaders ngOnInit uses).
  refreshConnections() {
    this.resetScrollState();
    if (this.inputData == "BUSINESS") {
      this.loadBusinessConnectionData();
    } else if (this.inputData == "COMMUNITY") {
      this.loadCommunityConnectionData();
    } else if (this.inputData == "HOME") {
      this.loadHomeConnectionData();
    }
  }

  infiniteScrollTriggered() {
    if (!this.isLoading && !this.stopScroll && this.inputData === "BUSINESS" && this.previousSearchAfterKey) {
      console.log("Infinite scroll triggered, loading more data with key:", this.previousSearchAfterKey);
      this.loadMoreBusinessConnections();
    } else {
      console.log("Scroll ignored - isLoading:", this.isLoading, "stopScroll:", this.stopScroll, 
                 "inputData:", this.inputData, "previousSearchAfterKey:", this.previousSearchAfterKey);
    }
  }

  loadMoreBusinessConnections() {
    if (this.isLoading || this.stopScroll) {
      return;
    }
    
    this.isLoading = true;
    console.log("Loading more connections with searchAfterKey:", this.previousSearchAfterKey);
    
    const businessId = localStorage.getItem('businessId');
    if (!businessId) {
      console.error("No businessId found. Cannot make API request.");
      this.isLoading = false;
      return;
    }
    
    const payload = {
      limit: this.pageSize,
      businessId: businessId,
      userId: localStorage.getItem('userId'),
      searchAfterKey: this.previousSearchAfterKey,
      searchContent: this.searchName || null
    };
    
    this.auth.create('business/connection/suggestion', payload).subscribe(
      (res) => {
        this.isLoading = false;
        
        if (res && res.code === '00000' && res.data) {
          const { data } = res;
          
          if (data.connectionInvites && data.connectionInvites.length > 0) {
            // Filter out any duplicates before adding to the list
            const newConnections = data.connectionInvites.filter(user => !this.loadedUserIds.has(user.userId));
            
            if (newConnections.length > 0) {
              // Add new users to both widget and modal lists
              newConnections.forEach(user => {
                this.loadedUserIds.add(user.userId);
                
                // Add to widget list
                this.userConnecction.push({...user});
                
                // Add to modal list with checked property
                const modalUser = {...user, checked: false};
                this.modalConnectionList.push(modalUser);
                
                // Add to filtered list if we're not filtering
                if (!this.searchName) {
                  this.filteredConnectionList.push(modalUser);
                } else if (
                  `${user.firstName} ${user.lastName}`.toLowerCase().includes(this.searchName.toLowerCase()) ||
                  (user.title && user.title.toLowerCase().includes(this.searchName.toLowerCase()))
                ) {
                  this.filteredConnectionList.push(modalUser);
                }
              });
              
              console.log(`Added ${newConnections.length} new connections, filtered out ${data.connectionInvites.length - newConnections.length} duplicates`);
              
              // Update searchAfterKey for next page
              if (data.searchAfterKey && data.searchAfterKey.length > 0) {
                // Check if the searchAfterKey is actually different by comparing the first element (timestamp)
                if (!this.previousSearchAfterKey || 
                    data.searchAfterKey[0] !== this.previousSearchAfterKey[0] || 
                    data.searchAfterKey[1] !== this.previousSearchAfterKey[1]) {
                  this.previousSearchAfterKey = data.searchAfterKey;
                  this.stopScroll = false;
                  console.log("Updated searchAfterKey:", this.previousSearchAfterKey);
                } else {
                  console.log("No new searchAfterKey found. Stopping scroll.");
                  this.stopScroll = true;
                }
              } else {
                console.log("No searchAfterKey in response. Stopping scroll.");
                this.stopScroll = true;
              }
            } else {
              console.log("All returned connections were duplicates. Stopping scroll.");
              this.stopScroll = true;
            }
          } else {
            console.log("No more connections to load");
            this.stopScroll = true;
          }
        } else {
          console.error("Invalid response format or error", res);
          this.stopScroll = true;
        }
      },
      err => {
        this.isLoading = false;
        console.error("API Error:", err);
        this.stopScroll = true;
      }
    );
  }

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };

  openModal(postTemplate: TemplateRef<any>) {
    // Make sure filtered list matches the full modal list
    this.resetFilteredList();
    
    // Reset search term
    this.searchName = '';
    
    // Reset pagination
    this.config.currentPage = 1;
    
    this.modalRef = this.modalService.show(postTemplate, { backdrop: 'static' });
  }

  closeModal() {
    this.modalRef.hide();
    setTimeout(() => {
      this.config.currentPage = 1;
      // Clear checked status in modal list
      this.modalConnectionList.forEach(user => {
        user.checked = false;
      });
      this.searchName = '';
      this.theChecker = false;
      this.selectedEntities = [];
      this.checkedList = [];
      
      // Reset filtered list
      this.filteredConnectionList = [...this.modalConnectionList];
    }, 1000);
  }

  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }

  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }

  duplicate(data) {
    var temp = [];
    var arr = data.filter(function (el) {
      // If it is not a duplicate, return true
      if (temp.indexOf(el) == -1) {
        temp.push(el);
        return true;
      }
      return false;
    });
    return arr;
  }

  selectedEntities: any = [];
  checkedList: any = [];
  page1: number = 1;

  onCheckboxChange(data, event) {
    // Update the checked status in both lists
    const userId = String(data.userId);
    
    // Find and update in modal list
    const modalUserIndex = this.modalConnectionList.findIndex(u => String(u.userId) === userId);
    if (modalUserIndex !== -1) {
      this.modalConnectionList[modalUserIndex].checked = event.target.checked;
    }
    
    // Find and update in filtered list
    const filteredUserIndex = this.filteredConnectionList.findIndex(u => String(u.userId) === userId);
    if (filteredUserIndex !== -1) {
      this.filteredConnectionList[filteredUserIndex].checked = event.target.checked;
    }
    
    if (event.target.checked) {
      this.selectedEntities.push(userId);
      this.checkedList.push(userId);
    } else {
      const index = this.selectedEntities.indexOf(userId);
      if (index !== -1) {
        this.selectedEntities.splice(index, 1);
        this.checkedList.splice(index, 1);
      }
      this.theChecker = false;
    }
    // Auto-tick Select All once every visible (search-filtered) row is checked.
    this.theChecker = this.filteredConnectionList.length > 0 && this.filteredConnectionList.every(u => u.checked);
  }

  dismiss() {
    this.modalRef.hide();
    this.config.currentPage = 1;
    setTimeout(() => {
      // Clear checked status in both lists
      this.modalConnectionList.forEach(user => {
        user.checked = false;
      });
      this.filteredConnectionList.forEach(user => {
        user.checked = false;
      });
      
      this.selectedEntities = [];
      this.checkedList = [];
      this.searchName = '';
      this.theChecker = false;
      
      // Reset filtered list
      this.filteredConnectionList = [...this.modalConnectionList];
    }, 1000);
  }

  theChecker: any;
  beingTyped: boolean = false;

  checkAll(event) {
    const isChecked = event.target.checked;
    
    // Apply to all visible connections in filtered list
    this.filteredConnectionList.forEach(user => {
      user.checked = isChecked;
      
      // Find and update in modal list too
      const modalUser = this.modalConnectionList.find(u => u.userId === user.userId);
      if (modalUser) {
        modalUser.checked = isChecked;
      }
      
      const userId = String(user.userId);
      
      if (isChecked) {
        // Add to selected entities if not already there
        if (!this.selectedEntities.includes(userId)) {
          this.selectedEntities.push(userId);
          this.checkedList.push(userId);
        }
      }
    });
    
    // If unchecking all, clear the arrays
    if (!isChecked) {
      this.selectedEntities = [];
      this.checkedList = [];
    }
  }

  onScrollDown() {
    this.infiniteScrollTriggered();
  }

  tempcheckedList: any = [];

  // Single-connection widget: Invite sends directly for that one user, no
  // modal. Reuses inviteAll by pre-selecting the sole connection; inviteAll's
  // modalRef.hide() is null-safe, so it is a no-op when no modal was opened.
  inviteSingle(item) {
    if (!item || !item.userId) { return; }
    this.selectedEntities = [String(item.userId)];
    this.inviteAll();
  }

  inviteAll() {
    if (this.selectedEntities.length === 0) {
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Please select users to invite',
        showConfirmButton: false,
        timer: 1500
      });
      return;
    }
    
    this.apicalled = true;
    
    if (this.inputData == 'BUSINESS') {
      var userIds = this.selectedEntities.join(',');
      var busId = localStorage.getItem('businessId');
      
      this.util.startLoader();
      this.auth.create("business/visitor/send/requests?businessId=" + busId + "&users=" + userIds + "&source=CONNECTION", null).subscribe(
        res => {
          this.util.stopLoader();
          this.apicalled = false;
          
          if (res.code == '00000') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Invitation sent successfully',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              // Store the IDs that were invited
              const invitedIds = new Set(this.selectedEntities);
              if (this.inviteTotal) {
                this.inviteTotal = Math.max(0, this.inviteTotal - invitedIds.size);
              }
              
              // Remove invited users from all lists
              this.userConnecction = this.userConnecction.filter(user => !invitedIds.has(String(user.userId)));
              this.modalConnectionList = this.modalConnectionList.filter(user => !invitedIds.has(String(user.userId)));
              this.filteredConnectionList = this.filteredConnectionList.filter(user => !invitedIds.has(String(user.userId)));
              
              // Remove from tracking set
              this.selectedEntities.forEach(id => {
                this.loadedUserIds.delete(id);
              });
              
              // Clear selections
              this.selectedEntities = [];
              this.checkedList = [];
              this.theChecker = false;
              
              if (this.userConnecction.length === 0) {
                this.showUI = false;
                this.hide(true);
              }

              this.modalRef?.hide();
            });
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Oops..',
              text: 'Something went wrong. Please try again later.',
              showConfirmButton: false,
              timer: 3000
            });
          }
        }, 
        err => {
          this.util.stopLoader();
          this.apicalled = false;
          
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: 'Failed to send invitations. Please try again later.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      );
    } else if (this.inputData == 'COMMUNITY') {
      var userIds = this.selectedEntities.join(',');
      
      var data: any = {};
      data.userId = userIds;
      data.entityId = localStorage.getItem('communityId');
      data.source = 'CONNECTION';
      data.sentBy = localStorage.getItem('userId');
      
      this.util.startLoader();
      this.auth.create("community/send/invite", data).subscribe(
        res => {
          this.util.stopLoader();
          this.apicalled = false;
          
          if (res.code == '0000') {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Invitation sent successfully',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              // Reset all data and reload
              this.resetScrollState();
              this.loadCommunityConnectionData();
              this.modalRef?.hide();
            });
          } else {
            Swal.fire({
              position: 'center',
              icon: 'info',
              title: 'Oops!',
              text: 'Something went wrong. Please, try again later',
              showConfirmButton: false,
              timer: 1500
            });
          }
        }, 
        err => {
          this.apicalled = false;
          this.util.stopLoader();
          
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: 'Failed to send invitations. Please try again later.',
            showConfirmButton: false,
            timer: 3000
          });
        }
      );
    }
  }

  pagecount(count) {
    this.config.currentPage = count;
    this.storedPage = count;
    this.updateVisiblePages();
  }

  updateVisiblePages() {
    let start = Math.max(1, this.config.currentPage - 2);
    let end = Math.min(this.config.totalPages, start + 4);

    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }

    this.visiblePages = [];
    for (let i = start; i <= end; i++) {
      this.visiblePages.push(i);
    }
  }

  routeToInvitePage(data) {
    let dataPass: any = {};
    dataPass.data = data;
    
    if (this.inputData == "COMMUNITY") {
      dataPass.id = localStorage.getItem('communityId');
      dataPass.master = this.page;
      dataPass.masterMenu = this.inputData;
      dataPass.menu = "Invite User";
      dataPass.widgetName = "CardComponent";
      this.router.navigate(['suggestions'], { queryParams: dataPass });
    } else if (this.inputData == "BUSINESS") {
      dataPass.id = localStorage.getItem('businessId');
      data.businessName = this._route.queryParams['_value'].businessName;
      
      dataPass.master = this.page;
      dataPass.masterMenu = this.inputData;
      dataPass.menu = "Invite User to Business";
      dataPass.widgetName = "CardComponent";
      this.router.navigate(['suggestions'], { queryParams: dataPass });
    }
  }

  hide(flag) {
    console.log('ConnectionsComponent hide: Calling hide with flag =', flag);
    this.commonDatahide.widgetName = "ConnectionsComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      console.log('ConnectionsComponent hide: Calling commonFunction callback');
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      console.log('ConnectionsComponent hide: Emitting via EventEmitter');
      this.commonFunction.emit(this.commonDatahide);
    } else {
      console.log('ConnectionsComponent hide: No commonFunction available to call');
    }
  }

  // Method to handle search
  onSearchChange() {
    if (this.inputData === "BUSINESS") {
      this.resetScrollState();
      
      const businessId = localStorage.getItem('businessId');
      if (!businessId) return;
      
      const payload = {
        limit: this.pageSize,
        userId: localStorage.getItem('userId'),
        businessId: businessId,
        searchAfterKey: null,
        searchContent: this.searchName || null
      };
      
      this.util.startLoader();
      this.auth.create('business/connection/suggestion', payload).subscribe(
        (res) => {
          this.util.stopLoader();
          
          if (res && res.code === '00000' && res.data) {
            const { data } = res;
            
            if (data.connectionInvites && data.connectionInvites.length > 0) {
              // Reset tracking of loaded user IDs
              this.userConnecction = [];
              this.modalConnectionList = [];
              this.loadedUserIds.clear();
              
              // Add users to both lists
              data.connectionInvites.forEach(user => {
                this.loadedUserIds.add(user.userId);
                
                // Add to widget list
                this.userConnecction.push({...user});
                
                // Add to modal list with checked property
                const modalUser = {...user, checked: false};
                this.modalConnectionList.push(modalUser);
              });
              
              // Reset filtered list
              this.filteredConnectionList = [...this.modalConnectionList];
              
              // Update searchAfterKey for next page
              if (data.searchAfterKey && data.searchAfterKey.length > 0) {
                this.previousSearchAfterKey = data.searchAfterKey;
                this.stopScroll = false;
              } else {
                this.stopScroll = true;
              }
            } else {
              this.userConnecction = [];
              this.modalConnectionList = [];
              this.filteredConnectionList = [];
              this.stopScroll = true;
            }
          } else {
            this.userConnecction = [];
            this.modalConnectionList = [];
            this.filteredConnectionList = [];
            this.stopScroll = true;
          }
        },
        err => {
          this.util.stopLoader();
          this.userConnecction = [];
          this.modalConnectionList = [];
          this.filteredConnectionList = [];
          this.stopScroll = true;
        }
      );
    }
  }
}